import { useTanstackSingleSuspenseQuery } from "@@/shared/hooks/use-tanstack-query";
import type { Me } from "@towni/common";
import * as React from "react";

const RequiredMeContext = React.createContext<Me | undefined>(undefined);

type Props = {
    readonly children?: React.ReactNode;
};

const RequiredMeProvider = ({ children }: Props) => {
    const meQuery = useTanstackSingleSuspenseQuery<Me>("/authentications/me", [
        "me",
    ]);

    return (
        <RequiredMeContext.Provider value={meQuery.data}>
            {children}
        </RequiredMeContext.Provider>
    );
};

const useRequiredMeFromContext = () => {
    const me = React.useContext(RequiredMeContext);
    if (me === undefined) {
        throw new Error(
            "useRequiredMeFromContext must be used within a RequiredMeProvider",
        );
    }
    return me;
};

export { RequiredMeContext, RequiredMeProvider, useRequiredMeFromContext };
